// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/kpi-header/kpi-title/kpi-title.less
// module id = 2786
// module chunks = 0 1